import {gql} from "@apollo/client";

export default class SunChartService {
	POWER_MONTH_ATTRIBUTES = [
		'id',
		'key',
		'fullpath',
		'month',
		'bought',
		'netFee',
		'transmission',
		'energyTax',
		'highPowerUsage',
		'highPowerFee',
		'authorityFee',
		'powerPrice',
		'powerSurcharge',
		'powerFee',
		'increasedFee',
		'soldHigh',
		'soldLow',
		'benefitPriceHigh',
		'benefitPriceLow',
		'priceSold',
		'productionFee',
		'powerFeeDiscount',
	];

	POWER_MONTH_ATTRIBUTES_STRING = this.POWER_MONTH_ATTRIBUTES.join(" ");

	CREATE_POWER_MONTH_MUTATION = gql`
	 mutation createPowerMonth(
	 		$key: String!, 
	 		$path: String!, 
	 		$date: String!, 
	 		$bought: Float!, 
	 		$netFee: Float!, 
	 		$transmission: Float!, 
	 		$energyTax: Float!, 
	 		$highPowerUsage: Float!, 
	 		$highPowerFee: Float!, 
	 		$authorityFee: Float!, 
	 		$powerPrice: Float!, 
	 		$powerSurcharge: Float!, 
	 		$powerFee: Float!, 
	 		$increasedFee: Float!, 
	 		$soldHigh: Float!, 
	 		$soldLow: Float!, 
	 		$benefitPriceHigh: Float!, 
	 		$benefitPriceLow: Float!, 
	 		$priceSold: Float!, 
	 		$productionFee: Float!, 
	 		$powerFeeDiscount: Float!) {
	  createPowerMonth(key: $key, published: true, path: $path, input: {
	  		month: $date,
	  		bought: $bought,
	  		netFee: $netFee,
	  		transmission: $transmission,
	  		energyTax: $energyTax,
	  		highPowerUsage: $highPowerUsage,
	  		highPowerFee: $highPowerFee,
	  		authorityFee: $authorityFee,
	  		powerPrice: $powerPrice,
	  		powerSurcharge: $powerSurcharge,
	  		powerFee: $powerFee,
	  		increasedFee: $increasedFee,
	  		soldHigh: $soldHigh,
	  		soldLow: $soldLow,
	  		benefitPriceHigh: $benefitPriceHigh,
	  		benefitPriceLow: $benefitPriceLow,
	  		priceSold: $priceSold,
	  		productionFee: $productionFee,
	  		powerFeeDiscount: $powerFeeDiscount,
	  }) {
	    success
	    message
	    output {
	     	${this.POWER_MONTH_ATTRIBUTES_STRING}
	    }
	  }
	}
  `;

	UPDATE_POWER_MONTH_MUTATION = gql`
	  mutation updatePowerMonth(
	  		$id: Int!,
	 		$bought: Float!, 
	 		$netFee: Float!, 
	 		$transmission: Float!, 
	 		$energyTax: Float!, 
	 		$highPowerUsage: Float!, 
	 		$highPowerFee: Float!, 
	 		$authorityFee: Float!, 
	 		$powerPrice: Float!, 
	 		$powerSurcharge: Float!, 
	 		$powerFee: Float!, 
	 		$increasedFee: Float!, 
	 		$soldHigh: Float!, 
	 		$soldLow: Float!, 
	 		$benefitPriceHigh: Float!, 
	 		$benefitPriceLow: Float!, 
	 		$priceSold: Float!, 
	 		$productionFee: Float!, 
	 		$powerFeeDiscount: Float!) {
	  	updatePowerMonth(
	  		id: $id, input: {
	  		bought: $bought,
	  		netFee: $netFee,
	  		transmission: $transmission,
	  		energyTax: $energyTax,
	  		highPowerUsage: $highPowerUsage,
	  		highPowerFee: $highPowerFee,
	  		authorityFee: $authorityFee,
	  		powerPrice: $powerPrice,
	  		powerSurcharge: $powerSurcharge,
	  		powerFee: $powerFee,
	  		increasedFee: $increasedFee,
	  		soldHigh: $soldHigh,
	  		soldLow: $soldLow,
	  		benefitPriceHigh: $benefitPriceHigh,
	  		benefitPriceLow: $benefitPriceLow,
	  		priceSold: $priceSold,
	  		productionFee: $productionFee,
	  		powerFeeDiscount: $powerFeeDiscount,
	  }) {
		  success
	      message 
		  output {
			${this.POWER_MONTH_ATTRIBUTES_STRING}
		  }
		}
	 }
	`;

	POWER_MONTH_QUERY = gql`
		     query getPowerMonth($path: String!)  {
			  getPowerMonth(fullpath: $path) {
				 ${this.POWER_MONTH_ATTRIBUTES_STRING}
			  }
			}
		    `;

	BASE_PATH = '/sunchart/orjan/economy/total';

	fields = [
		{ name: 'productionFee' , 'label': 'Avdrag', unit: 'kWh', priceUnit: 'öre/kWh', labelMatch: 'Avdrag', type: 'production' },
		{ name: 'priceSold' , 'label': 'Ersättning elproduktion', unit: 'kWh', priceUnit: 'öre/kWh', labelMatch: 'Ersättning elproduktion', type: 'production' },
		{ name: 'unbalancedFee' , 'label': 'Obalansavgift', unit: 'kWh', priceUnit: 'öre/kWh', labelMatch: 'Obalansavgift Svenska', type: 'production' },

		{ name: 'netFee' , 'label': 'Abonnemangsavgift', unit: 'månad', priceUnit: 'kr/månad', labelMatch: 'Abonnemangsavgift', type: 'net'},
		{ name: 'highPowerFee' , 'label': 'Effektavgift', unit: 'kW', priceUnit: 'kr/kW', labelMatch: 'Effektavgift', type: 'net'},
		{ name: 'transmission' , 'label': 'Överföringsavgift', unit: 'kWh', priceUnit: 'öre/kWh', labelMatch: 'Överföringsavgift', type: 'net'},
		{ name: 'energyTax' , 'label': 'Energiskatt', unit: 'kWh', priceUnit: 'öre/kWh', labelMatch: 'Energiskatt', type: 'net'},
		{ name: 'authorityFee' , 'label': 'Myndighetsavgift', unit: 'månad', priceUnit: 'kr/år', labelMatch: 'Myndighetsavgift', type: 'net'},
		{ name: 'compensationHigh' , 'label': 'Ersättning nätnytta, högpris', unit: 'kWh', priceUnit: 'öre/kWh', labelMatch: 'Ersättning nätnytta, högpris', type: 'net'},
		{ name: 'compensationLow' , 'label': 'Ersättning nätnytta, lågpris', unit: 'kWh', priceUnit: 'öre/kWh', labelMatch: 'Ersättning nätnytta, lågpris', type: 'net'},

		{ name: 'spotPrice' , 'label': 'Medelspotpris', unit: 'kWh', priceUnit: 'öre/kWh', labelMatch: 'Medelspotpris', type: 'consumption'},
		{ name: 'variableCosts' , 'label': 'Rörliga kostnader', unit: 'kWh', priceUnit: 'öre/kWh', labelMatch: 'Rörliga kostnader', type: 'consumption'},
		{ name: 'fixedMarkup' , 'label': 'Fast påslag', unit: 'kWh', priceUnit: 'öre/kWh', labelMatch: 'Fast påslag', type: 'consumption'},
		{ name: 'discount' , 'label': 'Rabatt el', unit: 'kWh', priceUnit: 'öre/kWh', labelMatch: 'Rabatt el', type: 'consumption'},
		{ name: 'fixedFee' , 'label': 'Fast avgift', unit: 'månad', priceUnit: 'kr/månad', labelMatch: 'Fast avgift', type: 'consumption'},
		{ name: 'powerFeeDiscount' , 'label': 'Rabatt månadsavgift', unit: 'månad', priceUnit: 'kr/månad', labelMatch: 'Rabatt månadsavgift', type: 'consumption'},
	];

	emptyRow =  {'date': '', 'amount': '', 'price': '', 'sum': ''}

	types = {
		production: { 'type': 'production', incVat: true, name: 'Producerat' },
		net: { 'type': 'net', incVat: true, name: 'Nät' },
		consumption: { 'type': 'consumption', incVat: false, name: 'Konsumtion' },
	}



	constructor(jsonApi, state) {
		this.jsonApi = jsonApi;
		this.state = state;


		this.state.add('loading', true);
		this.state.add('error', '');
		this.state.add('message', '');
		this.state.add('type', null);
		this.state.add('parseArea', '');

		const pm = this.getInitPowerMonth();
		this.state.add('powerMonth', pm);

		this.state.add('queryPath', this.BASE_PATH);

		this.fields.forEach((f) => {
			this.state.add(f.name, structuredClone(this.emptyRow));
		})

		Object.values(this.types).forEach((type) => {
			this.state.add(type.type, type);
		})
	}

	getInitPowerMonth() {
		const pm = {};
		this.POWER_MONTH_ATTRIBUTES.forEach(a => {
			pm[a] = 0;
		})
		pm.id = 0;
		pm.fullpath = this.BASE_PATH;
		return pm;
	}

	clearInputStates() {
		this.state.setParseArea('');
	}

	clearFields() {
		this.fields.forEach(f => {
			this.state.set(f.name, structuredClone(this.emptyRow));
		});
	}

	clearMessages() {
		this.state.set('message', '');
		this.state.set('error', '');
	}

	parseInput(value) {
		this.state.setParseArea(value);
		let matches;
		let type = '';
		let date = '';
		this.fields.forEach((f) => {
			const re = new RegExp(`^${f.labelMatch}.*?\\s+(\\d\\d\\d\\d-\\d\\d-\\d\\d) - \\d\\d\\d\\d-\\d\\d-\\d\\d\\s+([ \\d,]+) ${f.unit}\\s+([ -\\d,]+) ${f.priceUnit}\\s+([ -\\d,]+) kr`, 'sm');
			if (matches = re.exec(value)) {
				const row = {'date': matches[1], 'amount': matches[2], 'price': matches[3], 'sum': matches[4]}
				this.state.set(f.name, row);
				type = f.type;
				date = row.date;
			}
		})

		const incVat = !/Pris exkl. moms/.exec(value)
		if (type) {
			this.setVatType(type, incVat);
		}
		if (date) {
			this.state.setQueryPath(this.BASE_PATH + '/' + date.substring(0,4) + '/' + date.substring(5,7));
		}
	}

	setValue(name, dataField, value) {
		const row = this.state.get(name)
		row[dataField] = value
		this.state.set(name, row, true)
	};

	setVatType(type, checked) {
		const t = this.state.get(type)
		t.incVat = checked
		this.state.set(type, t, true);
	};

	createResponse(data) {
		const resp = data.createPowerMonth.output;
		this.state.setMessage(`Created ${resp.key} with id ${resp.id}`);
		this.state.setQueryPath(resp.fullpath);
		this.state.setPowerMonth({id: resp.id, fullpath: resp.fullpath});
		this.powerMonthRead(resp);
	};

	updateResponse(data) {
		const resp = data.updatePowerMonth.output;
		this.state.setMessage(`Update ${resp.key} with id ${resp.id}`);
		this.state.setPowerMonth({id: resp.id, fullpath: resp.fullpath});
		this.powerMonthRead(resp);
	};

	getCreateOptions() {
		let year;
		let month;
		let date;
		this.fields.forEach(f => {
			const val = this.state.get(f.name).date;
			if (!year && val) {
				year = val.substring(0, 4);
				month = val.substring(5, 7)
				date = val
			}
		})
		const resp = this.getOptions();
		resp.variables.key = month;
		resp.variables.path = this.BASE_PATH + '/' + year;
		resp.variables.date = date;
		return resp;
	};

	getUpdateOptions() {
		const resp = this.getOptions();
		resp.variables.id = parseInt(this.state.powerMonth.id);
		return resp;
	};

	getOptions() {
		const pm = this.state.powerMonth;
		const response = {
			variables: {
				bought: this.get('transmission', 'amount') || this.get('spotPrice', 'amount', pm.bought),
				netFee: this.get('netFee', 'sum', pm.netFee),
				transmission: this.get('transmission', 'price', pm.transmission),
				energyTax: this.get('energyTax', 'price') || pm.energyTax,
				highPowerUsage: this.get('highPowerFee', 'amount', pm.highPowerUsage),
				highPowerFee: this.get('highPowerFee', 'price', pm.highPowerFee),
				authorityFee: this.get('authorityFee', 'sum', pm.authorityFee),
				powerPrice: this.get('spotPrice', 'price', pm.powerPrice),
				powerSurcharge: (this.get('variableCosts', 'price') + this.get('fixedMarkup', 'price') + this.get('discount', 'price')) || pm.powerSurcharge || 0,
				powerFee: this.get('fixedFee', 'price', pm.powerFee),
				increasedFee:  pm.increasedFee || 0,
				soldHigh: this.get('compensationHigh', 'amount', pm.soldHigh),
				soldLow: this.get('compensationLow', 'amount', pm.soldLow),
				benefitPriceHigh: (this.get('compensationHigh', 'price') * -1)  || pm.benefitPriceHigh || 0,
				benefitPriceLow: (this.get('compensationLow', 'price') * -1) || pm.benefitPriceLow|| 0,
				priceSold: this.get('priceSold', 'price', pm.priceSold),
				productionFee: ((this.get('productionFee', 'price') + this.get('unbalancedFee', 'price')) * -1) || pm.productionFee || 0,
				powerFeeDiscount: (this.get('powerFeeDiscount', 'sum') * -1) || pm.powerFeeDiscount || 0,
			}
		}
		return response;
	}

	getFieldDefinition(fieldName) {
		const def = this.fields.filter(f => f.name === fieldName)
		return def[0];
	}
	get(fieldName, dataName, defaultValue) {
		const field = this.state.get(fieldName);
		let val = field[dataName];
		if (!val) {
			return defaultValue || 0;
		}
		val = val.replace(' ', '')
		val = val.replace(',', '.')
		val = Number.parseFloat(val);
		const def = this.getFieldDefinition(fieldName)
		const typeDef = this.state.get(def.type)

		if (def.type !== 'production' && !typeDef.incVat && (dataName === 'price' || dataName === 'sum')) {
			val = val * 1.25;
		}
		return val;
	}

	powerMonthRead(pm) {
		if (pm) {
			pm = structuredClone(pm);
			pm.id = parseInt(pm.id)
			pm.month = pm.month ? pm.month.substring(0, 10) : null
		}
		else {
			pm = this.getInitPowerMonth();
		}
		this.state.setPowerMonth(pm)
	}

	doCreate() {
		return this.state.powerMonth.fullpath === this.BASE_PATH;
	}
}
